package meineglasfaser.frontend.www.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.frontend.www.components.layouts.CONTAINER_CLASS
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul
import kotlin.js.Date

internal enum class FooterLinks(val title: String, val href: String, val newTab: Boolean) {
    IMPRINT_URL(
        title = "Impressum",
        href = "https://www.prometheus-network.at/Impressum.html",
        newTab = true,
    ),
    TERMS_OF_SERVICE_URL(
        title = "AGBs & Datenschutz",
        href = "https://www.prometheus-network.at/agb.pdf",
        newTab = true,
    ),
    WITHDRAWAL_POLICY_URL(
        title = "Widerrufsrecht",
        href = "/widerrufsrecht",
        newTab = false,
    ),
    CONTACT_URL(
        title = "Kontakt",
        href = "https://www.prometheus-network.at/Kontat.html#top",
        newTab = true,
    );
}

private object FooterCopyright {
    const val COMPANY_NAME = "Prometheus Network"
    val COPYRIGHT_TEXT by lazy {
        val year = Date().getFullYear()
        "© $year $COMPANY_NAME, Klöcklstrasse 12, 8061 St. Radegund"
    }
}

@Composable
fun ShopFooter() {
    Footer(attrs = { classes(CONTAINER_CLASS) }) {
        Nav {
            Ul {
                FooterLinks.entries.forEach { footerLink ->
                    key(footerLink.name) {
                        Li {
                            Anchor(href = footerLink.href, attrs = {
                                if (footerLink.newTab) target(ATarget.Blank)
                            }) {
                                Text(footerLink.title)
                            }
                        }
                    }
                }
            }
            Ul {
                Li {
                    Text(FooterCopyright.COPYRIGHT_TEXT)
                }
            }
        }
    }
}
